const renderBlocks = (data) => {
  // https://github.com/sanity-io/block-content-to-html
  const blocksToHtml = require('@sanity/block-content-to-html')
  const h = blocksToHtml.h
  const serializers = {
    types: {
      code: props => (
        h('pre', {className: props.node.language},
          h('code', props.node.code)
        )
      )
    }
  }

  const el = blocksToHtml({
    blocks: data,
    serializers: serializers
  })

  return el
}

export default renderBlocks



// WEBPACK FOOTER //
// ./src/renderBlocks.js